import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { HomeService } from '@services/home/home.service'

import{ HomeActions } from '@actions/index'

@Injectable()
export class HomeEffects {

  constructor(
    private actions$: Actions,
    private homeService: HomeService
  ) {}

}